function assign(x, y) {
  for (var k in y) {
    x[k] = y[k];
  }
  return x;
}

module.exports = assign;


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/assign.js
 ** module id = 653
 ** module chunks = 0
 **/